/***
 *
 *   USER
 *   shows the current user
 *   if user belongs to more than one account they can switch accounts here
 *
 **********/

import { UserOrganizationSwitch } from './UserOrganizationSwitch';
import Style from './user.tailwind.js';

type UserProps = Record<string, never>;

export function User(_props: UserProps) {
  return (
    <UserOrganizationSwitch
      className={`${Style.user} user-switch-bar`}
      nameClassName={Style.name}
      switchButtonClassName="user-switch-trigger"
    />
  );
}
